(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[799],{

/***/ 5554:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/london/google-analytics-agency",
      function () {
        return __webpack_require__(857);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ google_analytics_agency; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/utils/animation.ts
var animation = __webpack_require__(9428);
// EXTERNAL MODULE: ./src/components/reuseable/links/NextLink.tsx
var NextLink = __webpack_require__(9472);
// EXTERNAL MODULE: ./src/components/blocks/hero/index.ts + 35 modules
var hero = __webpack_require__(6978);
// EXTERNAL MODULE: ./src/components/reuseable/ContactFooterCombo.tsx
var ContactFooterCombo = __webpack_require__(9266);
;// CONCATENATED MODULE: ./src/data/answer-the-public/googleanalytics.ts
var googleanalytics = [
    {
        title: "when did Google Analytics 4 come out",
        url: ""
    },
    {
        title: "what Google Analytics can tell you",
        url: ""
    },
    {
        title: "web analytics agency",
        url: ""
    },
    {
        title: "where is Google Analytics hosted",
        url: ""
    },
    {
        title: "what Google Analytics can tell you",
        url: ""
    },
    {
        title: "what does Google Analytics look like",
        url: ""
    },
    {
        title: "what does Google Analytics show",
        url: ""
    },
    {
        title: "where is Google Analytics hosted",
        url: ""
    },
    {
        title: "why is Google Analytics good",
        url: ""
    },
    {
        title: "why Google Analytics is not showing visits",
        url: ""
    },
    {
        title: "why Google Analytics",
        url: ""
    },
    {
        title: "why Google Analytics is used",
        url: ""
    },
    {
        title: "why Google Analytics is important",
        url: ""
    },
    {
        title: "what Google Analytics can tell you",
        url: ""
    },
    {
        title: "what does Google Analytics show",
        url: ""
    },
    {
        title: "where is Google Analytics hosted",
        url: ""
    },
    {
        title: "what does Google Analytics look like",
        url: ""
    },
    {
        title: "where is Google Analytics hosted",
        url: ""
    },
    {
        title: "where is Google Analytics data stored",
        url: ""
    },
    {
        title: "where is my Google Analytics code",
        url: ""
    },
    {
        title: "how accurate is Google Analytics location",
        url: ""
    },
    {
        title: "where do i find Google Analytics",
        url: ""
    },
    {
        title: "will google ads call me",
        url: ""
    },
    {
        title: "can you set up Google Analytics for any website",
        url: ""
    },
    {
        title: "what Google Analytics can tell you",
        url: ""
    },
    {
        title: "what does Google Analytics look like",
        url: ""
    },
    {
        title: "how accurate is Google Analytics location",
        url: ""
    },
    {
        title: "how to analyse Google Analytics data",
        url: ""
    },
    {
        title: "how does Google Analytics 4 work",
        url: ""
    },
    {
        title: "how can Google Analytics help your business",
        url: ""
    },
    {
        title: "is Google Analytics gdpr compliant",
        url: ""
    },
    {
        title: "is Google Analytics illegal in eu",
        url: ""
    },
    {
        title: "are google ads good",
        url: ""
    },
    {
        title: "is Google Analytics data anonymous",
        url: ""
    },
    {
        title: "are google ads ppc",
        url: ""
    },
    {
        title: "what Google Analytics can tell you",
        url: ""
    },
    {
        title: "what does Google Analytics look like",
        url: ""
    },
    {
        title: "what does Google Analytics show",
        url: ""
    },
    {
        title: "what is Google Analytics data",
        url: ""
    },
    {
        title: "can analytics",
        url: ""
    },
    {
        title: "can you set up Google Analytics for any website",
        url: ""
    },
    {
        title: "can you use Google Analytics for social media",
        url: ""
    },
    {
        title: "can i see Google Analytics for any website",
        url: ""
    },
    {
        title: "what Google Analytics can tell you",
        url: ""
    },
    {
        title: "Google Analytics agencies in india",
        url: ""
    },
    {
        title: "Google Analytics company in india",
        url: ""
    },
    {
        title: "Google Analytics for company",
        url: ""
    },
    {
        title: "how much does it cost to use Google Analytics",
        url: ""
    },
    {
        title: "how to set up Google Analytics for a client",
        url: ""
    },
    {
        title: "is Google Analytics a good career",
        url: ""
    },
    {
        title: "what data does Google Analytics collect",
        url: ""
    },
    {
        title: "Google Analytics issues",
        url: ""
    },
    {
        title: "Google Analytics illegal",
        url: ""
    },
    {
        title: "Google Analytics and gdpr",
        url: ""
    },
    {
        title: "Google Analytics issues today",
        url: ""
    },
    {
        title: "data analytics agency",
        url: ""
    },
    {
        title: "Google Analytics asp.net",
        url: ""
    },
    {
        title: "google ads agency uk",
        url: ""
    },
    {
        title: "google ads agency london",
        url: ""
    },
    {
        title: "Google Analytics without consent",
        url: ""
    },
    {
        title: "Google Analytics without cookies",
        url: ""
    },
    {
        title: "Google Analytics without google account",
        url: ""
    },
    {
        title: "Google Analytics without cookie consent",
        url: ""
    },
    {
        title: "Google Analytics agencies in india",
        url: ""
    },
    {
        title: "how to set up Google Analytics for a client",
        url: ""
    },
    {
        title: "how much does it cost to use Google Analytics",
        url: ""
    },
    {
        title: "can i use Google Analytics for free",
        url: ""
    },
    {
        title: "Google Analytics and gdpr consent",
        url: ""
    },
    {
        title: "Google Analytics and gdpr",
        url: ""
    },
    {
        title: "Google Analytics abandoned cart",
        url: ""
    },
    {
        title: "Google Analytics case",
        url: ""
    },
    {
        title: "Google Analytics agencies in india",
        url: ""
    },
    {
        title: "how to set up Google Analytics for a client",
        url: ""
    },
    {
        title: "how to use Google Analytics effectively",
        url: ""
    },
    {
        title: "how to use Google Analytics for your business",
        url: ""
    },
    {
        title: "how to use Google Analytics",
        url: ""
    },
    {
        title: "Google Analytics agency account",
        url: ""
    },
    {
        title: "Google Analytics agencies in india",
        url: ""
    },
    {
        title: "Google Analytics and gdpr consent",
        url: ""
    },
    {
        title: "Google Analytics and gdpr",
        url: ""
    },
    {
        title: "Google Analytics organic search meaning",
        url: ""
    },
    {
        title: "data analytics agency",
        url: ""
    },
    {
        title: "Google Analytics vs google my business",
        url: ""
    },
    {
        title: "Google Analytics and gdpr",
        url: ""
    },
    {
        title: "Google Analytics and adwords",
        url: ""
    },
    {
        title: "data analytics agency",
        url: ""
    },
    {
        title: "Google Analytics and gdpr consent",
        url: ""
    },
    {
        title: "google ads agency london",
        url: ""
    },
    {
        title: "data analytics agency",
        url: ""
    },
    {
        title: "google ads agency uk",
        url: ""
    },
    {
        title: "Google Analytics alternative gdpr",
        url: ""
    },
    {
        title: "Google Analytics alternative gdpr compliant",
        url: ""
    },
    {
        title: "Google Analytics vs google my business",
        url: ""
    },
    {
        title: "Google Analytics and gdpr",
        url: ""
    },
    {
        title: "Google Analytics and gdpr consent",
        url: ""
    },
    {
        title: "data analytics agency",
        url: ""
    },
    {
        title: "Google Analytics and adwords",
        url: ""
    },
    {
        title: "Google Analytics agency account",
        url: ""
    },
    {
        title: "Google Analytics agencies in india",
        url: ""
    },
    {
        title: "how much does it cost to use Google Analytics",
        url: ""
    },
    {
        title: "c'est quoi Google Analytics",
        url: ""
    },
    {
        title: "is Google Analytics a good career",
        url: ""
    },
    {
        title: "can i use Google Analytics for free",
        url: ""
    }, 
];

// EXTERNAL MODULE: ./src/components/blocks/video/Video.tsx
var Video = __webpack_require__(2920);
// EXTERNAL MODULE: ./src/components/common/SEO.tsx
var SEO = __webpack_require__(2034);
// EXTERNAL MODULE: ./src/data/keywords.ts
var keywords = __webpack_require__(4870);
;// CONCATENATED MODULE: ./pages/london/google-analytics-agency/index.tsx




// -------- custom component -------- //






var answerThePublic = googleanalytics;
var details = {
    pageName: "Google Analytics Agency London",
    categories: "seo, web design",
    description: "SEOptimist Google Analytics Agency London improves your site ranking with a free technical SEO audit and the highest quality conversion rate optimisation services",
    parentDirectories: ""
};
var croPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "".concat(keywords.GoogleAnalytics[0].title),
                description: details.description,
                tag: details.categories,
                urlPT: "",
                urlENPT: "",
                url: "".concat(keywords.GoogleAnalytics[0].url, "/").concat(keywords.GoogleAnalytics[0].title.toLowerCase().replace(/ /g, "-")),
                image: "img/".concat(keywords.HomeList[0].title.toLowerCase().replace(/ /g, "-"), ".jpg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                        className: "content-wrapper bg-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: (0,animation/* fadeInAnimate */.St)("900ms"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Video["default"], {
                                    heading: keywords.GoogleAnalytics[0].title,
                                    title1: "AI",
                                    title2: "SEO",
                                    title3: "",
                                    movie: "/1.mp4",
                                    placeholder: "1-bg.jpg",
                                    button: "website-test",
                                    fontsize1: 150,
                                    fontsize2: 150,
                                    body: "",
                                    intro: " helps London companies improve Google ranking with in-depth Google Analytics analysis. If\xa0you\xa0want to accelerate your business online, we are the experts using proprietary technology and AI."
                                })
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "wrapper bg-light",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container py-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-md-6 mx-auto",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: keywords.GoogleAnalytics[0].title
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "In the dynamic and ever-evolving digital landscape, where competition is fierce and algorithms are constantly changing, it is crucial to have a comprehensive understanding of your website's technical performance. This is where SEOptimist, the leading ",
                                                        keywords.GoogleAnalytics[0].title,
                                                        ", steps in to provide valuable assistance. We specialize in delivering top-notch technical SEO audit services that empower businesses like yours to identify and address potential issues that may be impeding your online visibility and organic rankings."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "A technical SEO audit is a meticulous examination of your website's underlying technical infrastructure, ensuring that it is optimized for search engine crawlers and user experience. At SEOptimist, we recognize the critical role that technical factors play in the overall success of your online presence. Our team of experts conducts an in-depth analysis of various elements, including website speed, mobile-friendliness, site architecture, crawlability, indexation, and more. By scrutinizing these aspects, we can uncover any technical hindrances that may be preventing search engines from fully understanding and indexing your website."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "Through our technical SEO audit services, we provide you with actionable insights and recommendations to enhance your website's performance. We identify opportunities for optimization, propose solutions to address technical issues, and prioritize improvements that will have the greatest impact on your organic rankings. By leveraging our expertise and industry best practices, we help you unlock the full potential of your website, ensuring that it is primed for search engine success. As a leading ",
                                                        keywords.GoogleAnalytics[0].title,
                                                        ", we specialize in harnessing the power of data to drive measurable results for your business."
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "website-test"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero/* Hero1 */.lE, {
                                bgcolor: "bg-soft-primary mb-20 pt-20",
                                title: "",
                                lead: "",
                                body: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-center",
                                        id: "report",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-center fs-34 mb-0 mx-auto",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                    children: [
                                                        "GET YOUR FREE ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-fuchsia",
                                                            children: "TECHNICAL SEO REPORT"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-center fs-18 mx-auto",
                                                children: [
                                                    "Action the findings from the report or purchase ",
                                                    keywords.HomeList[8].title
                                                ]
                                            })
                                        ]
                                    }, 100)
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "wrapper bg-light",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container py-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-md-6 mx-auto",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: keywords.GoogleAnalytics[1].title
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "As a leading ",
                                                        keywords.GoogleAnalytics[1].title,
                                                        ", SEOptimist is dedicated to harnessing the immense value that this powerful tool brings to businesses seeking a comprehensive understanding of their website's performance. We take great pride in our team of seasoned experts who are not only well-versed in the intricacies of Google Analytics but are also certified professionals in utilizing this robust platform to its fullest potential. What sets us apart and makes us the best Google Analytics consultant is our unwavering commitment to diving deep into your analytics data, analyzing visitor behaviour, conversion rates, and other crucial metrics to unearth valuable insights and identify opportunities for growth and improvement."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "When you partner with SEOptimist as your trusted ",
                                                        keywords.GoogleAnalytics[1].title,
                                                        ", you gain access to a wealth of expertise and knowledge that can revolutionize your understanding of your website's performance. Our team of experts understands the nuances of Google Analytics and is adept at leveraging its features and functionalities to extract actionable insights. We delve into your analytics data with a meticulous eye, uncovering trends, patterns, and correlations that provide valuable context to your website's performance."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Through our in-depth analysis, we go beyond surface-level metrics and dig deeper into the intricacies of visitor behaviour. We scrutinize user engagement, bounce rates, conversion paths, and other key indicators to gain a holistic understanding of how visitors interact with your website. By identifying areas of improvement and untapped potential, we provide data-driven recommendations and strategies that enable you to optimize your website's performance, enhance user experience, and drive meaningful results."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "As a ",
                                                        keywords.GoogleAnalytics[1].title,
                                                        ", our mission is to empower you with the knowledge and insights needed to make informed decisions and achieve your business goals. We go the extra mile to ensure that you not only have access to valuable data but also understand its implications and how it ties into your overall digital strategy. Our team is always available to guide you through the intricacies of Google Analytics, answer your questions, and provide ongoing support to ensure that you maximize the benefits of this powerful tool."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: keywords.GoogleAnalytics[2].title
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "At SEOptimist, our ",
                                                        keywords.GoogleAnalytics[2].title,
                                                        " services are designed to be a catalyst for your business success. We understand that every organization has unique goals and aspirations, and our team of ",
                                                        keywords.GoogleAnalytics[2].title,
                                                        " experts works closely with you to understand your specific business objectives. By gaining a deep understanding of your vision and aligning it with your digital marketing strategies, we can unlock the full potential of your data and provide actionable insights that drive tangible results."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "Whether your aim is to increase website traffic, boost conversions, enhance user experience, or achieve a combination of these goals, our ",
                                                        keywords.GoogleAnalytics[2].title,
                                                        " team is here to guide you. We delve into the vast amount of data at your disposal and make sense of the numbers, uncovering hidden trends, patterns, and correlations that hold the key to unlocking growth opportunities. By analyzing the behaviour of your website visitors, identifying conversion bottlenecks, and pinpointing areas for improvement, we empower you to make data-driven decisions that have a significant impact on your digital marketing efforts."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "Our ",
                                                        keywords.GoogleAnalytics[2].title,
                                                        " approach goes beyond just providing you with raw data. We believe in translating complex analytics metrics into actionable insights that you can easily understand and implement. Our team of experts excels at distilling complex data into clear and concise recommendations, ensuring that you have a roadmap for success. We guide you through the intricacies of your data, providing you with a comprehensive understanding of the factors influencing your website's performance and offering practical strategies to optimize your digital marketing campaigns."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "As your trusted ",
                                                        keywords.GoogleAnalytics[2].title,
                                                        " partner, we are committed to your success. We continuously monitor and analyze your data, keeping a close eye on trends, shifts, and emerging opportunities. Our agile approach enables us to adapt and refine our recommendations in real-time, ensuring that you stay ahead of the curve and maintain a competitive edge in the digital landscape. With our expertise and dedication to delivering exceptional results, we strive to be your go-to resource for web analytics consulting."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: keywords.GoogleAnalytics[3].title
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "In addition to Google Analytics, our expertise extends to a wide range of web analytics tools and platforms. As a dedicated ",
                                                        keywords.GoogleAnalytics[3].title,
                                                        ", we leverage cutting-edge technologies and industry best practices to gather, analyze, and interpret data from various sources. From tracking user behaviour to monitoring campaign performance, we ensure that you have a comprehensive view of your online ecosystem. SEOptimist is a complete and trustworthy ",
                                                        keywords.GoogleAnalytics[3].title,
                                                        "."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: keywords.GoogleAnalytics[4].title
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "At SEOptimist, we pride ourselves on being a leading ",
                                                        keywords.GoogleAnalytics[4].title,
                                                        ", dedicated to taking your advertising campaigns to new heights of success. We understand the significance of Google Ads as a powerful advertising platform and the impact it can have on driving quality traffic to your website. As a ",
                                                        keywords.GoogleAnalytics[4].title,
                                                        "-based, we leverage our expertise in web analytics and combine it with the advanced capabilities of Google's advertising platform to deliver exceptional results for our clients."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Our team of skilled professionals possesses in-depth knowledge and experience in creating targeted and optimized Google Ads campaigns. We conduct thorough research and analysis to identify the most relevant keywords, demographics, and audience segments for your business. By understanding your target audience and their preferences, we craft compelling ads that capture their attention and drive them to take action. Our focus is not just on increasing traffic, but on attracting high-quality visitors who are more likely to convert into customers."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "One of the key advantages of partnering with SEOptimist ",
                                                        keywords.GoogleAnalytics[4].title,
                                                        " is our integration of data from Google Analytics into your campaigns. We believe in the power of data-driven decision-making, and by leveraging insights from Google Analytics, we continually refine and optimize your ads to maximize return on investment (ROI). We analyze performance metrics, monitor conversion rates, and make data-driven adjustments to ensure that your ad spend is optimized and delivering the desired results."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "At SEOptimist, we are committed to providing the best to our clients. As a",
                                                        " ",
                                                        keywords.GoogleAnalytics[4].title,
                                                        ", we continually thrive to stay ahead of industry trends and updates. We keep a close eye on the ever-changing digital landscape, ensuring that our strategies and campaigns are aligned with the latest best practices and innovations. Our team undergoes continuous training and stays up-to-date with the latest Google Ads features and tools, enabling us to offer cutting-edge solutions that drive exceptional results for our clients."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: keywords.GoogleAnalytics[5].title
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "As your trusted analytics partner, we understand that every business is unique. That's why we offer customized solutions tailored to your specific needs. ",
                                                        "",
                                                        keywords.GoogleAnalytics[5].title,
                                                        " SEOptimist takes the time to understand your goals, target audience, and competitive landscape. We then develop a data-driven strategy that aligns with your business objectives, leveraging the power of Google Analytics and other web analytics tools to optimize your digital presence. Choosing SEOptimist is choosing the best ",
                                                        keywords.GoogleAnalytics[5].title,
                                                        " based."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: keywords.GoogleAnalytics[6].title
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "In the ever-expanding realm of ",
                                                        keywords.GoogleAnalytics[6].title,
                                                        ", SEOptimist distinguishes itself with its unwavering commitment to a holistic approach to data-driven decision-making. While many agencies focus solely on surface-level metrics, we delve deep into the wealth of data available to uncover hidden patterns and insights that can truly transform your business. Our team of seasoned experts combines their expertise in SEO, web analytics, and Google Ads to provide you with a comprehensive view of your online performance, empowering you to make informed decisions that drive sustainable growth."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "What sets us apart from other ",
                                                        keywords.GoogleAnalytics[6].title,
                                                        " is our dedication to guiding you every step of the way. We understand that navigating the complex world of data analytics can be overwhelming, which is why we strive to be more than just a service provider. Our team takes the time to understand your unique business needs, goals, and challenges, allowing us to tailor our strategies and recommendations specifically to your requirements. We believe in forming a strong partnership with our clients, working collaboratively to unlock the full potential of your e-commerce business."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "When you choose SEOptimist as your",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                            title: keywords.EcommerceSEO[0].title,
                                                            href: "/" + keywords.EcommerceSEO[0].url + "/" + keywords.EcommerceSEO[0].title.toLowerCase().replace(/ /g, "-")
                                                        }),
                                                        ", you gain access to a wealth of expertise and knowledge. We have a proven track record of delivering tangible results for our clients, helping them achieve sustainable growth in the ever-evolving digital landscape. Our team stays at the forefront of industry trends and innovations, continuously refining our methodologies to ensure that we provide you with the most up-to-date and effective solutions. We are committed to your success and are dedicated to providing you with exceptional service and support throughout your journey."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "Take the first step towards unlocking the full potential of your e-commerce business. Contact us today to discover how our expertise in SEO, web analytics, and Google Ads can drive sustainable growth for your business. Visit our website to explore our",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                            title: keywords.SEOPricing[0].title,
                                                            href: "/" + keywords.SEOPricing[0].url + "/" + keywords.SEOPricing[0].title.toLowerCase().replace(/ /g, "-")
                                                        }),
                                                        " ",
                                                        "options, our",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                            title: keywords.CRO[2].title,
                                                            href: "/" + keywords.CRO[0].url + "/" + keywords.CRO[0].title.toLowerCase().replace(/ /g, "-")
                                                        }),
                                                        ", learn more about the world of SEO, and see firsthand the transformative impact our analytics services can have on your online presence. Trust SEOptimist, your",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                            title: keywords.HomeList[0].title,
                                                            href: "/"
                                                        }),
                                                        ", to be your strategic partner in achieving your business goals and thriving in the digital landscape."
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactFooterCombo/* default */.Z, {
                        location: "london"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var google_analytics_agency = (croPage);


/***/ }),

/***/ 1147:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var components_reuseable_links_NextLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9472);




var GoogleAppBtn = function() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "d-flex justify-content-center justify-content-lg-start",
        style: slideInDownAnimate("900ms"),
        children: [
            /*#__PURE__*/ _jsx("span", {
                style: slideInDownAnimate("1200ms"),
                children: /*#__PURE__*/ _jsx(NextLink, {
                    href: "#",
                    className: "btn btn-primary btn-icon btn-icon-start rounded me-2",
                    title: /*#__PURE__*/ _jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("i", {
                                className: "uil uil-apple"
                            }),
                            " App Store"
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx("span", {
                style: slideInDownAnimate("1500ms"),
                children: /*#__PURE__*/ _jsx(NextLink, {
                    href: "#",
                    className: "btn btn-green btn-icon btn-icon-start rounded",
                    title: /*#__PURE__*/ _jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("i", {
                                className: "uil uil-google-play"
                            }),
                            " Google Play"
                        ]
                    })
                })
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (GoogleAppBtn)));


/***/ }),

/***/ 7632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6523);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2546);







// ==================================================================
var Carousel = function(props) {
    var children = props.children, slideClassName = props.slideClassName, _spaceBetween = props.spaceBetween, spaceBetween = _spaceBetween === void 0 ? 30 : _spaceBetween, _slidesPerView = props.slidesPerView, slidesPerView = _slidesPerView === void 0 ? 3 : _slidesPerView, _pagination = props.pagination, pagination = _pagination === void 0 ? true : _pagination, _navigation = props.navigation, navigation = _navigation === void 0 ? true : _navigation, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
        "children",
        "slideClassName",
        "spaceBetween",
        "slidesPerView",
        "pagination",
        "navigation"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), prevEl = ref[0], setPrevEl = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), nextEl = ref1[0], setNextEl = ref1[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .tq, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        spaceBetween: spaceBetween,
        slidesPerView: slidesPerView,
        modules: [
            swiper__WEBPACK_IMPORTED_MODULE_2__/* .Pagination */ .tl,
            swiper__WEBPACK_IMPORTED_MODULE_2__/* .Navigation */ .W_,
            swiper__WEBPACK_IMPORTED_MODULE_2__/* .Autoplay */ .pt
        ],
        navigation: navigation ? {
            prevEl: prevEl,
            nextEl: nextEl
        } : false,
        pagination: pagination ? {
            clickable: true
        } : false
    }, others), {
        children: [
            children.map(function(slide, i) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_3__/* .SwiperSlide */ .o5, {
                    className: slideClassName,
                    children: slide
                }, i);
            }),
            navigation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "swiper-navigation",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        role: "button",
                        ref: function(node) {
                            return setPrevEl(node);
                        },
                        className: "swiper-button swiper-button-prev swiper-button-disabled"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        role: "button",
                        ref: function(node) {
                            return setNextEl(node);
                        },
                        className: "swiper-button swiper-button-next"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Carousel);


/***/ }),

/***/ 9266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_blocks_footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7702);
/* harmony import */ var data_keywords__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4870);
/* harmony import */ var hooks_useLogVisitor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9588);


// -------- custom component -------- //



var ContactInfoDI = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 873).then(__webpack_require__.bind(__webpack_require__, 873));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(873)
            ];
        }
    },
    ssr: false
});
var ContactFooterCombo = function(param) {
    var location = param.location;
    (0,hooks_useLogVisitor_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "wrapper bg-light",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactInfoDI, {
                    location: location,
                    title: "Free Consultation",
                    body: "Reach out to us and we will get back to you right away with a customised plan to get you more sales.",
                    email: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].email,
                    phone: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].phone
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_blocks_footer__WEBPACK_IMPORTED_MODULE_2__/* .Footer1 */ .gH, {
                    address: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address1,
                                ",",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address2,
                                ",",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " ",
                                data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].address3
                            ]
                        })
                    ],
                    email: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].email,
                    phone: data_keywords__WEBPACK_IMPORTED_MODULE_3__.SiteIdentity[0].phone
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactFooterCombo);


/***/ }),

/***/ 2744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);





// ====================================================
var FigureImage = function(props) {
    var className = props.className, src = props.src, width = props.width, height = props.height, others = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "className",
        "src",
        "width",
        "height"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("figure", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: className
    }, others), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            width: width,
            height: height,
            src: src,
            alt: "demo",
            quality: "100"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FigureImage);


/***/ }),

/***/ 9486:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useLightBox = function() {
    var lightboxLoad = function() {
        var GLightbox = __webpack_require__(7727);
        GLightbox({
            loop: false,
            moreLength: 0,
            zoomable: false,
            autoplayVideos: true,
            touchNavigation: true,
            selector: "*[data-glightbox]",
            // slideExtraAttributes: { poster: '' },
            plyr: {
                config: {
                    fullscreen: {
                        enabled: false,
                        iosNative: false
                    },
                    youtube: {
                        noCookie: true,
                        rel: 0,
                        showinfo: 0,
                        iv_load_policy: 3
                    },
                    vimeo: {
                        byline: false,
                        portrait: false,
                        title: false,
                        transparent: false
                    }
                }
            }
        });
    };
    useEffect(function() {
        lightboxLoad();
    }, []);
    return null;
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useLightBox)));


/***/ }),

/***/ 9588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
// useLogVisitor.js


var useLogVisitor = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var visitor = Array.isArray(router.query.visitor) ? router.query.visitor[0] : router.query.visitor;
        if (visitor) {
            fetch("/api/log-visitor/?visitor=".concat(encodeURIComponent(visitor))).then(function(response) {
                return response.json();
            }).then(function(data) {
                console.log("Visitor logged:", data.message);
            }).catch(function(error) {
                console.error("Error logging visitor:", error);
            });
        }
    }, [
        router.query.visitor
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useLogVisitor);


/***/ }),

/***/ 9:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var Check = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        viewBox: "0 0 409.6 409.6",
        xmlns: "http://www.w3.org/2000/svg",
        className: "svg-inject icon-svg ".concat(className || "icon-svg-md text-primary mb-3"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M204.8 409.6C91.9 409.6 0 317.7 0 204.8c0-49.9 18.2-98.1 51.2-135.5 4.4-5 12-5.5 17-1.1s5.5 12 1.1 17c-29.1 33-45.2 75.5-45.2 119.5 0 99.6 81.1 180.7 180.7 180.7s180.7-81.1 180.7-180.7S304.4 24.1 204.8 24.1c-27.3-.1-54.2 6.1-78.7 18-6 2.9-13.2.4-16.1-5.6-2.9-6-.4-13.2 5.6-16.1C143.4 6.9 173.9-.1 204.8 0c112.9 0 204.8 91.9 204.8 204.8s-91.9 204.8-204.8 204.8z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-fill",
                d: "M349.4 204.8c0 79.8-64.7 144.6-144.6 144.6S60.2 284.6 60.2 204.8 125 60.2 204.8 60.2 349.4 125 349.4 204.8z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M204.8 361.4c-86.4 0-156.6-70.2-156.6-156.6S118.4 48.2 204.8 48.2s156.6 70.2 156.6 156.6-70.2 156.6-156.6 156.6zm0-289.1c-73.1 0-132.5 59.4-132.5 132.5s59.4 132.5 132.5 132.5 132.5-59.5 132.5-132.5S277.9 72.3 204.8 72.3z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "lineal-stroke",
                d: "M200.9 246.7c-8.8 0-17.2-3.5-23.5-9.7L145 204.5c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l32.5 32.5c3.6 3.5 9.3 3.5 12.8 0l49.8-49.9c4.7-4.7 12.3-4.7 17 0s4.7 12.3 0 17L224.4 237c-6.2 6.2-14.7 9.7-23.5 9.7z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Check);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2634,1271,7857,7727,4090,4870,4556,4992,9774,2888,179], function() { return __webpack_exec__(5554); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);